import { render, staticRenderFns } from "./livePage.vue?vue&type=template&id=7c46ccea&scoped=true&"
import script from "./livePage.vue?vue&type=script&lang=ts&"
export * from "./livePage.vue?vue&type=script&lang=ts&"
import style0 from "./livePage.vue?vue&type=style&index=0&id=7c46ccea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c46ccea",
  null
  
)

export default component.exports